import { useEffect, useRef, useState } from "react";
import { NavLink } from "react-router-dom";

const IMAGE_ASPECT = 3300 / 2400;

const HITS = [
  { to: "/about", label: "About", width: 38.5 },
  { to: "/current-focus", label: "Currently", width: 22 },
  { to: "/resume", label: "Resume", width: 39.5 },
];

function measureLogoRect(width, height, scale) {
  const canvasAspect = width / Math.max(height, 1);
  const widthFrac =
    canvasAspect > IMAGE_ASPECT
      ? (IMAGE_ASPECT / canvasAspect) * scale
      : scale;
  const heightFrac =
    canvasAspect > IMAGE_ASPECT
      ? scale
      : (canvasAspect / IMAGE_ASPECT) * scale;

  return {
    left: (0.5 - widthFrac / 2) * 100,
    top: (0.5 - heightFrac / 2) * 100,
    width: widthFrac * 100,
    height: heightFrac * 100,
  };
}

export default function HomeNav({ active = false, logoScale = 0.72 }) {
  const ref = useRef(null);
  const [box, setBox] = useState({
    left: 14,
    top: 14,
    width: 72,
    height: 72,
  });

  useEffect(() => {
    const parent = ref.current?.parentElement;
    if (!parent) return undefined;

    const update = () => {
      const { width, height } = parent.getBoundingClientRect();
      setBox(measureLogoRect(width, height, logoScale));
    };

    update();
    const observer = new ResizeObserver(update);
    observer.observe(parent);
    return () => observer.disconnect();
  }, [logoScale]);

  return (
    <nav
      ref={ref}
      className={`gorillian-hits ${active ? "is-active" : ""}`}
      aria-hidden={!active}
    >
      <div
        className="gorillian-hit-frame"
        style={{
          left: `${box.left}%`,
          top: `${box.top}%`,
          width: `${box.width}%`,
          height: `${box.height}%`,
        }}
      >
        {HITS.map((hit) => (
          <NavLink
            key={hit.to}
            to={hit.to}
            className="gorillian-hit"
            aria-label={hit.label}
            tabIndex={active ? 0 : -1}
            style={{ flex: `0 0 ${hit.width}%` }}
          />
        ))}
      </div>
    </nav>
  );
}
